import React, { Component } from 'react';
import {connect} from "react-redux";

class GoogleMaps extends Component {

    constructor(props) {
        super(props);
        this.state = {
            map: '',
            click: '',
            ion_customer: [],
            turf_coord: [],
            turf_name: '',
            poly: [],
            reps: [],
            selectedUser: '',
            selectedTeam: '001o0000016mZ7bAAE'
        };


        this.mapClick = this.mapClick.bind(this);
        this.mapSetup = this.mapSetup.bind(this);
        this.addTurf = this.addTurf.bind(this);
        this.removeTurf = this.removeTurf.bind(this);
        this.saveTurf = this.saveTurf.bind(this);
        this.changeUser = this.changeUser.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getTeamInfo = this.getTeamInfo.bind(this);

    }

    handleChange(event) {

        const target = event.target;
        const name = target.name;

        this.setState({
            [name]:target.value
        });

    }

    removeTurf(){

        this.setState({
            turf_coord: []
        });
        this.state.poly.setMap(null);

    }

    componentDidMount(){

        const google = window.google;
        let mainMap = new google.maps.Map(document.getElementById('map'), {
            center: {lat: 40.3004, lng: 40.3004},
            zoom: 8
        });


        mainMap.panTo({lat: 40.315444930000965, lng: -111.69090140934554});
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
                let pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };

                mainMap.panTo(pos);
                mainMap.setZoom(14);

            });
        } else {

        }



        this.setState({
            map: mainMap
        }, () => {
            this.mapClick();
            // this.mapSetup();
        });



        let teamId = this.props.state.user.team_id;
        fetch('https://dev.iondeveloper.com/api/rep/round-robin/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method":"get_team_members",
                    "account_id": teamId
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {

            this.setState({
                reps: data.data,
                selectedUser: data.data[0]['sfid']
            });


        }.bind(this));


    }

    getTeamInfo(event){

        let teamId = event.target.value;
        this.setState({loading: true});
        fetch('https://dev.iondeveloper.com/api/rep/round-robin/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method":"get_team_members",
                    "account_id": teamId
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {

            this.setState({
                reps: data.data,
                loading: false,
                selectedTeam: teamId,
                selectedUser: this.state.reps[0]
            });

        }.bind(this));

    }

    mapSetup(){


        fetch('https://dev.iondeveloper.com/api/rep/maps/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method": "get_customer_locations",
                    "contact_id": "003o00000154qOeAAI",
                    "account_id": "001o0000010acdSAAQ"
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {

            this.setState({
                ion_customer: data.data
            });

            const google = window.google;
            for (let entry of data['data']['all']){

                let marker = new google.maps.Marker({
                    position: {lat: parseFloat(entry['Lt']), lng: parseFloat(entry['Ln'])},
                    title: "hey"
                });
                marker.setMap(this.state.map);
            }

        }.bind(this));



    }

    changeUser(event){

        if (this.state.turf_coord.length > 1){
            this.removeTurf();
        }

        let value = event.target.value;
        this.setState({
            selectedUser: value
        });

        fetch('https://dev.iondeveloper.com/api/rep/maps/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method":"get_map_areas_for_user",
                    "assigned_to": value
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {

            console.log(data);

        });

    }

    addTurf(){

        if (this.state.turf_coord.length > 1) {
            this.state.poly.setMap(null);
        }


        let polycords = this.state.turf_coord;
        const google = window.google;
        // Construct the polygon.
        let poly = new google.maps.Polygon({
            paths: polycords,
            strokeColor: '#FF0000',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#FF0000',
            fillOpacity: 0.35
        });
        this.setState({
           poly: poly
        });
        this.state.poly.setMap(this.state.map);


    }

    saveTurf(){

        console.log("saving turf");

        let body =                 {
            "method": "create_map_area",
            "assigned_to": this.state.selectedUser,
            "team_id": this.state.selectedTeam,
            "map_info": { name: this.state.turf_name, cords: this.state.turf_coord}
        };
        console.log(body);

        fetch('https://dev.iondeveloper.com/api/rep/maps/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
            method: 'post',
            body: JSON.stringify(
                body
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {

            console.log(data);

        });

    }



    mapClick(){

        this.state.map.addListener("click", function(event){
            let latitude = event.latLng.lat();
            let longitude = event.latLng.lng();

            this.setState({
                    turf_coord: [...this.state.turf_coord, {lat: latitude, lng: longitude}]
            });
            this.addTurf();
            console.log(this.state.turf_coord);


        }.bind(this));

    }


    render() {

        let reps = [];
        for (let i = 0; i < this.state.reps.length; i++){
            reps.push(<option key={i} value={this.state.reps[i]['sfid']}>{this.state.reps[i]['fname']} {this.state.reps[i]['lname']}</option>);
        }

        let multi = [];
        multi.push(
            <div key={0} className="UserSelect">
                <select  selected="none" className="select-box" onChange={this.changeUser}>
                    {reps}
                </select>
            </div>
        );

        let removeTurf = [];
        if (this.state.turf_coord.length > 1){

            removeTurf = (
                <div>
                    <button className="turf-button" onClick={this.removeTurf}>Remove Turf</button>
                    <button className="turf-button" onClick={this.saveTurf}>Save Turf</button>
                    <input className="turf-button turf-input" type="text" name="turf_name" value={this.state.turf_name} onChange={this.handleChange} placeholder="Turf Name" />
                </div>
            );
        }

        return (
            <div>
                <div className="map-controls">
                    {/*<button className="turf-button" onClick={this.addTurf}>ADD TURF</button>*/}
                    <select value={this.state.selectedTeam} onChange={this.getTeamInfo} selected="none" className="select-box select-box-teams">
                        <option value="001o0000016mZ7bAAE">North Denver Sales Team</option>
                        <option value="001o00000116xdAAAQ">Denver Sales Team</option>
                        <option value="001o0000010DtdwAAC">Colorado Springs Sales Team</option>
                        <option value="001o0000017WJuGAAW">New Mexico Sales Team</option>
                        <option value="0011N00001RLEj3QAH">Virginia Sales Team</option>
                        <option value="0011N000017yAllQAE">Vegas 1</option>
                        <option value="0011N00001msjWQQAY">Vegas 2</option>
                        <option  value="001o0000010EHdSAAW">Austin Sales Team</option>
                        <option  value="0011N00001g8KwUQAU">San Antonio Sales Team</option>
                    </select>
                    {multi}
                    {removeTurf}
                </div>
                <div className="map-container">
                    <div id="map"></div>

                </div>
            </div>

        );
    }
}


function mapStateToProps(state) {
    return {
        state: state
    };
}

export default connect(mapStateToProps)(GoogleMaps);




// WEBPACK FOOTER //
// ./src/components/pages/Map/Map.js